import React from 'react'
import styles from "./Fees.module.scss";
const Fees = () => {
    return (
        <div className={styles.fee_content}>
            <div className={styles.legal_header}>
                <h1>STBL Fee Schedule</h1>
              
            </div>

            <div className={styles.legal_section}>
                <h3>Marketplace Fees <span>Trading</span></h3>
                <table className={styles.fees_table}>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Fee Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Standard Trade</td>
                            <td>$0.10 – $0.20 per trade (varies by asset/size)</td>
                        </tr>
                        <tr>
                            <td>Metal Premium</td>
                            <td>Silver: ~$.20 | Gold: $5 (relative to spot)</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={styles.legal_section}>
                <h3>Withdrawal Fees <span>Transfers</span></h3>
                <table className={styles.fees_table}>
                    <thead>
                        <tr>
                            <th>Method</th>
                            <th>Fee</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Fiat (Wire)</td>
                            <td>No charge (bank fees may still apply)</td>
                        </tr>
                        <tr>
                            <td>Cryptocurrency</td>
                            <td>Network gas fees apply</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={styles.legal_section}>
                <h3>Storage & Custody <span>Physical</span></h3>
                <p>Minimal long-term storage fees may apply for physical metal backing.</p>
                <ul>
                    <li>Users may offset storage through participation in yield programs (if available)</li>
                    <li>Fees are calculated based on the weight and type of metal</li>
                </ul>
            </div>

            <div className={styles.legal_section}>
                <h3>Redemption Fees <span>Physical</span></h3>
                <p>Physical redemption includes fabrication, shipping, and handling fees.</p>
                <div className={styles.legal_footer}>
                    <p>Final redemption pricing is confirmed at the time of your request.</p>
                </div>
            </div>

            <div className={styles.legal_footer}>
                <p>We may update these fees from time to time. Changes will be posted on this page, and continued use of the Platform constitutes acceptance of the updated Terms.</p>
            </div>
        </div>
    )
}

export default Fees
